function activateCard(card, panel, cards) {
  const idx = card.dataset.stepIndex;
  const template = document.getElementById(`hiw-template-${idx}`);
  if (!template) return;

  cards.forEach((c) => c.classList.remove("bg-background"));
  card.classList.add("bg-background");

  panel.innerHTML = "";
  panel.appendChild(template.content.cloneNode(true));
  panel.classList.remove("hidden");
}

export function register() {
  const cards = document.querySelectorAll("[data-step-index]");
  const panel = document.getElementById("hiw-details-panel");
  let activeIndex = null;

  // Open first card by default
  const first = cards[0];
  if (first) {
    activateCard(first, panel, cards);
    activeIndex = first.dataset.stepIndex;
  }

  cards.forEach((card) => {
    card.addEventListener("click", () => {
      const idx = card.dataset.stepIndex;

      if (activeIndex === idx) {
        panel.classList.add("hidden");
        card.classList.remove("bg-background");
        activeIndex = null;
        return;
      }

      activateCard(card, panel, cards);
      activeIndex = idx;
    });
  });
}
